import { styled } from '@mui/material/styles';

import Paper from '@/components/ui/Paper/Paper';

export const HeatingAssistantWrapper = styled('div')(({ theme }) => ({
  minHeight: 676,
  width: 746,

  [theme.breakpoints.down('md')]: {
    minHeight: 'auto',
    width: '100%',
  },
  [theme.breakpoints.up('md')]: {
    position: 'relative',
  },
}));

export const Form = styled(Paper, {
  shouldForwardProp: prop => prop !== 'isStep0',
})(({ theme, isStep0 }) => ({
  [theme.breakpoints.up('md')]: {
    width: 746,
    minHeight: 728,
  },
  [theme.breakpoints.down('md')]: {
    padding: isStep0 ? 0 : theme.spacing(2, 3, 0, 4),
  },
}));

export const BackButton = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',

  [theme.breakpoints.up('md')]: {
    position: 'absolute',
    top: -30,
  },
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(0, 2, 3.5),
  },
}));
